import { createContext, useContext } from "react";
import { GLTF } from "three/examples/jsm/loaders/GLTFLoader";

export const CurrentModelContext = createContext<GLTF | undefined>(undefined);

export const {
  Consumer: CurrentModelConsumer,
  Provider: CurrentModelProvider,
} = CurrentModelContext;

export const useCurrentModel = (): GLTF =>
  useContext(CurrentModelContext) as GLTF;
